import { ALL_LAYOUT_ARGS, CONTAINER_ARGS, Metadata, pick } from '../../../utils/spds/metadata';
import FlexColumn from './flex/column.gjs';
import FlexReverseColumn from './flex/reverse-column.gjs';
import FlexReverseRow from './flex/reverse-row.gjs';
import FlexRow from './flex/row.gjs';
import GridContainer from './grid/container.gjs';
import Super from '../core/base.gjs';

const METADATA = Metadata.define({
  description: 'A flexible layout component that can be used to create a variety of layouts',
  extends: [
    ALL_LAYOUT_ARGS,
    pick(CONTAINER_ARGS, ['grid', 'reverse', 'tag', { name: 'column', default: true }]),
  ],
  name: 'Variable Layout',
});

export default class SpdsLayoutVariable extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-layout-variable';

  get column() {
    return this.argOrDefault('column');
  }

  get component() {
    if (this.grid) return GridContainer;

    if (this.reverse) {
      return this.column ? FlexReverseColumn : FlexReverseRow;
    }

    return this.column ? FlexColumn : FlexRow;
  }

  get grid() {
    return this.argOrDefault('grid');
  }

  get reverse() {
    return this.argOrDefault('reverse');
  }

  get tag() {
    return this.argOrDefault('tag');
  }

  <template>
    <this.component
      @alignContent={{@alignContent}}
      @alignItems={{@alignItems}}
      @alignSelf={{@alignSelf}}
      @area={{@area}}
      @areas={{@areas}}
      @autoFlow={{@autoFlow}}
      @columns={{@columns}}
      @flex={{@flex}}
      @flexWrap={{@flexWrap}}
      @gap={{@gap}}
      @gridArea={{@gridArea}}
      @gridAutoColumns={{@gridAutoColumns}}
      @gridAutoFlow={{@gridAutoFlow}}
      @gridAutoRows={{@gridAutoRows}}
      @gridColumn={{@gridColumn}}
      @gridRow={{@gridRow}}
      @gridTemplateAreas={{@gridTemplateAreas}}
      @gridTemplateColumns={{@gridTemplateColumns}}
      @gridTemplateRows={{@gridTemplateRows}}
      @id={{@id}}
      @justifyContent={{@justifyContent}}
      @justifyItems={{@justifyItems}}
      @justifySelf={{@justifySelf}}
      @order={{@order}}
      @row={{@row}}
      @rows={{@rows}}
      @tag={{this.tag}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      class={{this.classes}}
      data-test-spds-layout-variable
      ...attributes
    >
      {{yield}}
    </this.component>
  </template>
}

export const VARIABLE_LAYOUT_METADATA = SpdsLayoutVariable.metadata;
